import { render, staticRenderFns } from "./AppointmentsCell.vue?vue&type=template&id=1fc3f38e&scoped=true&"
import script from "./AppointmentsCell.vue?vue&type=script&lang=js&"
export * from "./AppointmentsCell.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsCell.vue?vue&type=style&index=0&id=1fc3f38e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc3f38e",
  null
  
)

export default component.exports